import Panel from "./Panel.jsx";

function sentimentTone(sentiment) {
  if (sentiment === "bullish") return "bg-mint/10 text-mint border-mint/30";
  if (sentiment === "bearish") return "bg-rose/10 text-rose border-rose/30";
  return "bg-white/5 text-slate-300 border-white/10";
}

function sentimentLabel(sentiment) {
  if (sentiment === "bullish") return "Бычий";
  if (sentiment === "bearish") return "Медвежий";
  return "Нейтральный";
}

function horizonLabel(horizon) {
  if (horizon === "intraday") return "Внутри дня";
  if (horizon === "short-term") return "Краткосрочно";
  if (horizon === "medium-term") return "Среднесрочно";
  if (horizon === "long-term") return "Долгосрочно";
  return horizon;
}

export default function NewsPanel({ analysis = {}, news = [], newsScore = 0 }) {
  const articles = analysis.articles?.length ? analysis.articles : news.slice(0, 6);

  return (
    <Panel
      title="ИИ-анализ новостей"
      icon="spark"
      right={<span className="rounded-md bg-mint/10 px-2 py-1 text-sm font-semibold text-mint">{newsScore}/100</span>}
    >
      <div className="grid gap-4 lg:grid-cols-[1fr_1.15fr]">
        <div>
          <div className="mb-3 flex flex-wrap items-center gap-2">
            <span className={`rounded-md border px-2 py-1 text-xs font-semibold ${sentimentTone(analysis.overallSentiment)}`}>
              {sentimentLabel(analysis.overallSentiment)}
            </span>
            <span className="rounded-md border border-white/10 bg-white/5 px-2 py-1 text-xs text-slate-300">
              {analysis.source ?? "Анализ"}
            </span>
          </div>
          <p className="text-sm leading-relaxed text-slate-300">
            {analysis.summary ?? "Анализ новостей пока недоступен."}
          </p>
          <div className="mt-4 grid gap-4 sm:grid-cols-2">
            <div>
              <h3 className="mb-2 text-sm font-semibold text-white">Драйверы</h3>
              <ul className="space-y-2 text-sm text-slate-300">
                {(analysis.keyDrivers ?? []).slice(0, 6).map((driver) => (
                  <li key={driver} className="border-l-2 border-mint/60 pl-3">
                    {driver}
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h3 className="mb-2 text-sm font-semibold text-white">Риски</h3>
              <ul className="space-y-2 text-sm text-slate-300">
                {(analysis.riskWarnings ?? []).slice(0, 6).map((warning) => (
                  <li key={warning} className="border-l-2 border-gold/70 pl-3">
                    {warning}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
        <div className="max-h-[430px] overflow-auto pr-1 thin-scrollbar">
          {articles.slice(0, 8).map((article, index) => (
            <article key={`${article.title}-${index}`} className="border-b border-white/10 py-3 first:pt-0 last:border-b-0">
              <div className="mb-2 flex flex-wrap items-center gap-2">
                <span className={`rounded-md border px-2 py-1 text-xs font-semibold ${sentimentTone(article.sentiment)}`}>
                  {sentimentLabel(article.sentiment)}
                </span>
                {article.impact != null ? <span className="text-xs text-muted">Влияние {article.impact}/100</span> : null}
                {article.horizon ? <span className="text-xs text-muted">{horizonLabel(article.horizon)}</span> : null}
              </div>
              <h3 className="text-sm font-semibold leading-snug text-white">{article.title}</h3>
              <p className="mt-1 text-sm leading-snug text-slate-400">{article.reason ?? article.summary}</p>
            </article>
          ))}
        </div>
      </div>
    </Panel>
  );
}
